// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"57ccc327","194":"8ef43d6e","319":"33a1f48f","499":"32615f6d","523":"a1634f2c","674":"3a07a4c0","968":"2007bc04"}[chunkId] + ".chunk.js";
};